import { theme } from '../../Common/Credentials'
import '../NewCreationUI.css'

const SelectableRadio = ({ checked, onClick, size = "md", color }) => {
    return (
        <div
            onClick={onClick}
            className={`selectable-radio ${size} ${checked ? `checked  ${ theme === "classic" ? "tw-bg-[#fffdfb]" : "tw-bg-gradient-to-r tw-from-blue-600 tw-to-indigo-600"} !tw-border-none` : ''}`}
            // style={{backgroundColor:checked && color,borderColor:checked && color}}
            role="radio"
            aria-checked={checked}
        >
            {checked && (
                <svg
                    className={size}
                    viewBox="0 0 24 24"
                    fill="none"
                >
                    <path
                        d="M5 13l4 4L19 7"
                        stroke="#ffffff"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )}
        </div>
    )
}

export { SelectableRadio }